export default "__VITE_ASSET__tV_4fVkf__"